import React from "react";

const IconTwitter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <title>Twitter/X</title>
    <path d="M51.2 20c0 15.4-11 33.2-31 33.2-6.1 0-11.9-2-16.8-5.3.9.1 1.7.2 2.6.2 5.1 0 9.8-1.9 13.5-5-4.7-.1-8.8-3.5-10.2-8.1.6.2 1.3.2 2 .2 1 0 2-.2 2.9-.4-5-1.1-8.7-5.8-8.7-11.4v-.2c1.5.9 3.1 1.4 4.9 1.4-2.9-2-4.8-5.7-4.8-9.7 0-2.1.5-4.1 1.5-5.9 5.3 7 13.5 11.7 22.5 12.2-.2-.9-.3-1.8-.3-2.7 0-6.4 4.9-11.7 10.9-11.7 3.1 0 6 1.4 7.9 3.7 2.5-.5 4.8-1.5 7-2.9-.8 2.8-2.6 5-4.8 6.4 2.2-.3 4.3-.9 6.2-1.9-1.4 2.3-3.3 4.4-5.4 6.1 0 .7.1 1.3.1 1.8z" />
  </svg>
);

export default IconTwitter;
